export const companies = {
    namespaced: true,
    state: {
        addressesStatus: 'initial',
        addresses: [],
        managersStatus: 'initial',
        managers: {},
        oneInvoiceAddress: false
    },
    mutations: {
        SET_ADDRESSES_STATUS(state, addressesStatus) {
            state.addressesStatus = addressesStatus
        },
        SET_ADDRESSES(state, addresses) {
            state.addresses = addresses
        },
        SET_ADDRESSES_ONE_INVOICE_ADDRESS(state, oneInvoiceAddress) {
            state.oneInvoiceAddress = oneInvoiceAddress
        },
        SET_MANAGERS_STATUS(state, managersStatus) {
            state.managersStatus = managersStatus
        },
        SET_MANAGERS(state, managers) {
            state.managers = managers
        }
    },
    actions: {
        fetchAddresses({ commit, getters, dispatch }) {
            commit('SET_ADDRESSES_STATUS', 'pending')
            return this.$api.get('client/v2/companies/addresses').then(response => {
                if(response.status === 200) {
                    commit('SET_ADDRESSES', response.data.data)
                    commit('SET_ADDRESSES_ONE_INVOICE_ADDRESS', response.data.one_invoice_address)
                    commit('SET_ADDRESSES_STATUS', 'idle')
                }
            }).catch(() => {
                dispatch('resetFromInitialState', { module: 'companies' }, { root: true }).then(() => {
                    commit('SET_ADDRESSES_STATUS', 'idle')
                })
            })
        },
        fetchManagers({ commit, getters, dispatch }) {
            commit('SET_MANAGERS_STATUS', 'pending')
            return this.$api.get('client/v2/companies/managers').then(response => {
                if(response.status === 200) {
                    commit('SET_MANAGERS', response.data.data)
                    commit('SET_MANAGERS_STATUS', 'idle')
                }
            }).catch(() => {
                dispatch('resetFromInitialState', { module: 'companies' }, { root: true }).then(() => {
                    commit('SET_MANAGERS_STATUS', 'empty')
                })
            })
        }
    },
    getters: {
        addressesStatus: state => state.addressesStatus,
        addresses: state => state.addresses,
        managersStatus: state => state.managersStatus,
        managers: state => state.managers,
        oneInvoiceAddress: state => state.oneInvoiceAddress
    }
}
